import { twMerge } from "tailwind-merge";
import React from "react";
// className should contain className for a particular icon, e.g. qr-icon
// Usage would be the following: <Icon className="qr-icon" />
export const Icon = ({ className, ...rest }) => {
    return React.createElement("i", { className: twMerge("icon", className), ...rest });
};
//# sourceMappingURL=Icon.js.map